<template>
	<section id="about">
    
        <div class="">        
            <div class="col-md-8 col-md-offset-2 col-sm-12">
                    <div class="feature_header text-center">
                        <h3 class="feature_title">Galería de <b>Videos</b></h3>
                          <!--
                        <h4 class="feature_sub">Click en el icono <i class="fa fa-bars" aria-hidden="true"></i> para desplegar la lista de videos. </h4>-->
                     
                       
                  
                        <div class="divider"></div>
                        
                    </div>
                </div>
             </div>
             <div class="container">
              <div class="row">

                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div class="col-xs-6 col-sm-4 col-md-3 col-lg-3 video-ex"
                      v-for="(video,indice) in videos"
                      v-if="video.visible">

                    <iframe  width="100%" height="auto" 
                      v-bind:src="video.url" frameborder="0" allowfullscreen></iframe>
                      <p style="text-align:center;">{{video.nombre}} {{indice + 1 }}</p>

                 </div>
                   
              </div>
            </div>
          </div>
    </section>
</template>
<script>
	export default{
		props : ['videos'],
		methods : {
			/*estado : function(index){
        let visible = this.videos[index].visible = !this.videos[index].visible;

        let id = this.videos[index].id;
        this.$http.patch('videos-adn/' + id + '.json',{
          visible : visible}).then(respuesta => {console.log(respuesta)})
        }*/
      }
		}
</script>


// WEBPACK FOOTER //
// src/VideoSectionComponent.vue